module.exports = __webpack_public_path__ + "static/media/rope.be60d42e.png";